import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema } from './config';


const EditServiceTicket = ({ appt_id }) => {
  const [initValues, setInitialValues] = useState({...initialValues, appointment_id: appt_id});

  useEffect(() => {
    setInitialValues({...initialValues, appointment_id: appt_id});
  }, [appt_id]);

  return (
    <EditForm title={"Check In"} initialValues={initValues} fields={fields} schema={schema} url={"service_tickets"} invalidate_queries={[['appointments', 'service_tickets']]}>
      
     </EditForm>
  );
}

export default EditServiceTicket;